import { render, staticRenderFns } from "./DropdownMenu.vue?vue&type=template&id=7ab2587c&"
import script from "./DropdownMenu.vue?vue&type=script&setup=true&lang=js&"
export * from "./DropdownMenu.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports